<template>
  <div class="rate">
    <el-date-picker
      v-model="planTime"
      format="yyyy-MM-dd HH:mm:ss"
      value-format="yyyy-MM-dd HH:mm:ss"
      type="datetime"
      placeholder="选择日期时间"
      @change="dateChange"
    ></el-date-picker>
  </div>
</template>
<script>
export default {
  props: ['item', 'pindex'],
  data() {
    return {
      planTime: '',
      startTime: {
        disabledDate: (date) => {
          if (
            this.item.value.dateTimeAttribute.endDate &&
            this.item.value.dateTimeAttribute.startDate
          ) {
            return (
              date >
                new Date(
                  this.item.value.dateTimeAttribute.endDate.replace(/-/g, '/')
                ) ||
              date <
                new Date(
                  this.item.value.dateTimeAttribute.startDate.replace(/-/g, '/')
                )
            )
          } else if (this.item.value.dateTimeAttribute.endDate) {
            return (
              date >
              new Date(
                this.item.value.dateTimeAttribute.endDate.replace(/-/g, '/')
              )
            )
          } else if (this.item.value.dateTimeAttribute.startDate) {
            return (
              date <
              new Date(
                this.item.value.dateTimeAttribute.startDate.replace(/-/g, '/')
              )
            )
          }
        },
      },
    }
  },
  created: function () {
    if (this.item.value.dateTimeAttribute.answer !== '') {
      // this.startTime = this.item.value.dateTimeAttribute.answer
      this.planTime = this.item.value.dateTimeAttribute.answer
    }
    // console.log(this.item.value.rateAttribute)
    //  this.value = this.item.value.rateAttribute.defaultValue;
  },
  methods: {
    dateChange(val) {
      this.item.value.dateTimeAttribute.answer = val
    },
  },
  watch: {
    startTime(val) {
      console.log(val)
    },
  },
  components: {},
}
</script>
<style lang="less" scoped>
.rate .rate-item {
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-color: grey !important;
}
.rate .cube-rate-item {
  color: #d6ddef;
}
.rate .cube-rate-item.cube-rate-item_active {
  color: orange !important;
  /* background-color: orange; */
}
.rate .cube-rate li {
  /* width: 10%; */
  text-align: center;
  height: 30px;
  display: inline-block;
  margin: 0;
}
.rate .cube-rate li img {
  width: 100%;
  height: 100%;
}
.rate .cube-rate-item.cube-rate-item_active img {
  border: 2px solid rgb(66, 134, 241);
}
.rate .icon-star {
  color: #d6ddef;
}
.rate .cubeic-star {
  font-size: 18px;
}
</style>


